// TODO document existing keys

// Все новые ключи должны быть задокументированы!
const DEBUG_STORE_KEYS = {
	'profile_clear_pending': false,
	'profile-to-import': '',
	'disableAllSaves': false,
	'disableBeforeUnloadSave': false,
	'log_save_requests': false,
	'localReplicaDisabled': false,
	'chestsExtraLogs': false,
	'forceAdError': false,
	'forceFakeAds': false,
	'forcedLocalSaveError': '',
	'adReplacement': '',
	'viralMechanicChance': 0,
	'event-dates': {},
	'vk-promo-dates': {},
	'skipWinVideo': false,
	'skipChestContent': false,
	'skipReturnFromAfkScreen': false,
	'skipBrokenLevelReset': false,
	'pauseBeforePaymentProcess': false,
	'pauseBeforePurchaseConsumption': false,
	'disableVkEventsLogging': false,
	'PlatformPaymentsDisabled': false,
	'platformRequestsDelaySeconds': 0,
	'clearConsoleOnStart': false,
	'accountsState': '',
	'throwErrorOnStart': false,
	'localStorageType': '',
	'serverSaveIntervalMs': 0,
	'detailedSaveLogs': false,
	'viewerId': '',
	'signature': '',
	'testPromoGift': null as configs.PromoGift,
	'serverRequestsDelaySeconds': 0,
	'serverRequestsDelayApis': [] as string[],
	'infraErrorsScheduled': false,
	'networkErrorsScheduled': false,
	'idbErrorsScheduled': 0 as number,
	'idbErrorName': '' as string,
	'idbErrorMessage': '' as string,
	'idbVersion': 1 as number,
	'disableMultiTabCheck': false,
	'rewardedAdPreloadIntervalMs': 3 * 60 * 1000,
	'logProfilesComparison': false,
	'localTimeOffsetMinutes': 0 as number,
	'serverTimeOffsetMinutes': 0 as number,
	'alwaysShowInters': false as boolean,
	'forceInterstitials': false as boolean,
	'maxDesktopWidth': 0 as number,
	'chooseEventRotation': false as boolean,
	'chooseEventDifficulty': false as boolean,
	'chooseEventRatingPlace': 0 as number,
	'storageSuperPrizeType': '' as string,
	'storageSuperPrizeChance': 0.5 as number,
	'storageSkipSwitchFieldAnimation': false as boolean,
	'useFbFakeBannerAd': false as boolean,
	'skipInterstitialOnStart': 0 as number,
	'logRandomRewardsWeights': 0 as number,
	'disableAllTutors': 0 as number,
	'logTimeOnPageVisible': 0 as number,
	'conesDropTimerCoef': 1 as number,
	'conesDurationMinutes': 0 as number,
	'conesMaxRewardsInLine': 0 as number,
	'bannersAutoStartDisabled': 0 as number,
	'bannersRefreshIntervalSeconds': 0 as number,
	'guestId': 0 as number,
	'guestCreatedAt': 0 as number,
	'skipEventRewardsDisplay': 0 as number,
	'xsollaSandboxMode': 0 as number,
	'logServerRequestData': 0 as number,
	'logServerResponseData': 0 as number,
	'loadStartedAt': '',
	'loadTimings': '',
	'loadPageWasHidden': '',
	'assetsLoadDelaySeconds': 0 as number,
	'assetsLoadDelayBundles': '',
	'assetsLoadErrorsScheduled': 0 as number,
	'specialOffersDates': {} as SpecialOffersDates,
	'megaOffersDates': {} as MegaOffersDates,
	'logSegmentationCalculation': false as boolean,
	'megaOfferPopupFrequencies': {} as megaOfferPopupFrequencies,
	'loseWebglContextOnPayment': false as boolean,
} as const;

export type DebugStoreKey = keyof typeof DEBUG_STORE_KEYS;

/**
 * Class representing a debug store for storing and retrieving values from local storage.
 */
class DebugStore {
	// TODO use types from DEBUG_STORE_KEYS to narrow down return type
	public get(key: DebugStoreKey, _defaultValue?: string): string | null {
		try {
			const item = localStorage.getItem(key);
			if (item !== null) {
				return item;
			}

			return _defaultValue ?? null;
		} catch (e) {
			return _defaultValue ?? null;
		}
	}

	// TODO use types from DEBUG_STORE_KEYS to narrow down value type
	public set(key: DebugStoreKey, value: string): boolean {
		try {
			localStorage.setItem(key, value);
			return true;
		} catch (e) {
			return false;
		}
	}

	public remove(key: DebugStoreKey): boolean {
		try {
			localStorage.removeItem(key);
			return true;
		} catch (e) {
			return false;
		}
	}

	public removeAll(): boolean {
		try {
			localStorage.clear();
			return true;
		} catch (e) {
			return false;
		}
	}
}

// TODO make it an EventTarget
export const DEBUG_STORE = new DebugStore();

export type SpecialOffersDates = {
	[realm: string]: CustomOffersDates;
};

export type MegaOffersDates = {
	[realm: string]: CustomOffersDates;
};

export type CustomOffersDates = {
	[offerId: string]: {
		startTimestamp: number;
		endTimestamp: number;
	};
};

export type megaOfferPopupFrequencies = {
	[offerId: string]: number;
};
